<div class="form-group" [formGroup]="form">
  <h3 style="text-align: left;" [title]="control.label">{{ control.label | translate }}</h3>

  @switch(control.className){
    @case('TextAreaControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="rectangle" height="65px"></kendo-skeleton> }
      @if(control.loaded) { <kendo-textarea id="{{ control.id }}" [rows]="3" formControlName="{{control.id}}"></kendo-textarea> }
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('TextControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <kendo-textbox id="{{ control.id }}" formControlName="{{control.id}}"></kendo-textbox> }
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('ListBoxControl')
    {
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if (control.loaded) {
      <app-list-box [control]="control" id="{{ control.id }}"> </app-list-box>
      }
    </div>
    }
    @case('PasswordControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      <input class="form-textbox" kendoTextBox type="password" id="{{ control.id }}" formControlName="{{control.id}}" placeholder="Password" />
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('ToggleControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="circle" animation="pulse" height="14px"></kendo-skeleton> }
      @if(control.loaded) { <input type="checkbox" kendoCheckBox formControlName="{{control.id}}" />}
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('DateControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <kendo-datepicker id="{{ control.id }}" calendarType="infinite" formControlName="{{control.id}}"></kendo-datepicker> }
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('NumericControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <app-money-field [control]="control" id="{{ control.id }}"></app-money-field> }
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('UrlControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <app-url-field [control]="control" id="{{ control.id }}"></app-url-field> }
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('EditorControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <kendo-editor #editor id="{{ control.id }}" formControlName="{{control.id}}"></kendo-editor> }
      <app-dialog #upload [editor]="editor"></app-dialog>
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('UploadControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <app-upload-image [control]="control" id="{{ control.id }}"> </app-upload-image> }
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @case('GridControl'){
    <div class="form-element" style="width:70%">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <app-grid-kendo-card [control]="control" id="{{ control.id }}"> </app-grid-kendo-card> }
    </div>
    }
    @case('RadioControl'){
    <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      <label class="radio-inline"><input type="radio" id="{{control.id}}_unspecified" formControlName="{{control.id}}" [value]="null" />Unspecified</label>
      <label class="radio-inline"><input type="radio" id="{{control.id}}_true" formControlName="{{control.id}}" [value]="true" />Yes</label>
      <label class="radio-inline"><input type="radio" id="{{control.id}}_false" formControlName="{{control.id}}" [value]="false" />No</label>
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
    @default{
      <div class="form-element">
      @if(!control.loaded) { <kendo-skeleton shape="text" animation="pulse" height="24px"></kendo-skeleton> }
      @if(control.loaded) { <app-select-field [control]="control" (onChange)="onSelectChange(control, $event)"></app-select-field> }
      @if(submitted && form.controls[control.id].errors) { <div class="validation" [innerHtml]="form.controls[control.id].errors?.['error']"></div> }
    </div>
    }
  }
</div>
